import * as Yup from "yup";

const DeptCreationSchema = Yup.object({
  name: Yup.string().required("name is required"),
  code: Yup.string().required("Code is required"),
});
export default DeptCreationSchema;
